module.exports = __webpack_public_path__ + "img/2016_alloottees_bohol.3bf0a1c3.jpg";